
import LookupDomain from "./LookupDomain.vue";
import TransferDomain from "./TransferDomain.vue";

export default {
  components: {
    TransferDomain,
    LookupDomain,
  },
};
